module.exports = __webpack_public_path__ + "img/barber.c826368d.png";